import { TableCompHead } from '../../../../components/ui';
interface IProps {
  moduleData: any;
  isView: boolean;
}

// const border = '1px solid black';

const THead = ({ moduleData, isView }: IProps) => {
  return (
    <thead
      style={{
        position: 'sticky',
        width: '100%',
        top: '-.5rem',
        border: '1px solid black',
        zIndex: '1',
        backgroundColor: 'rgb(79, 129, 189)',
        // background: '#fff',
        color: '#fff',
      }}
    >
      <TableCompHead
        colSpan={37}
        rowSpan={3}
        labels={[]}
        values={[]}
        heading="4M CHANGE SHEET"
      />
      <tr style={{ border: '1px solid black' }}>
        <th rowSpan={2} style={{ minWidth: '100px' }}>
          SR NO.
        </th>
        <th rowSpan={2} style={{ minWidth: '150px' }}>
          DATE
        </th>
        <th rowSpan={2} style={{ minWidth: '150px' }}>
          TIME
        </th>
        <th rowSpan={2} style={{ minWidth: '200px' }}>
          M/C NO.
        </th>
        <th rowSpan={2} style={{ minWidth: '150px' }}>
          ASSY. STATION NO.
        </th>
        <th rowSpan={2}>PART NAME/NO.</th>
        <th rowSpan={2}>OPERATION</th>
        <th rowSpan={2} style={{ minWidth: '150px' }}>
          NATURE OF CHANGE
        </th>
        <th rowSpan={2} style={{ minWidth: '250px' }}>
          CHANGE INFORMATION DETAIL
        </th>
        <th rowSpan={2} style={{ minWidth: '250px' }}>
          ACTION TAKEN
        </th>
        <th rowSpan={1} colSpan={2} style={{ minWidth: '200px' }}>
          CHANGE SKILL LEVEL INFORMATION
        </th>
        <th rowSpan={2}>PLANNED/UNPLANED</th>
        <th rowSpan={2}>ABNORMAL</th>
        <th rowSpan={2} style={{ minWidth: '100px' }}>
          RESPONSIBLITY
        </th>
        <th rowSpan={2}>PRODUCTION DATE</th>
        <th rowSpan={1} colSpan={3}>
          SETUP APPROVAL
        </th>
        <th rowSpan={1} colSpan={5}>
          RETRO CHECK
        </th>
        <th rowSpan={1} colSpan={5}>
          CONTAINMENT
        </th>
        <th rowSpan={2}>TRACEABILITY</th>
        <th rowSpan={1} colSpan={2}>
          REMARKS
        </th>
        <th rowSpan={2} style={{ minWidth: '300px' }}>
          PROCEDURE
        </th>
        <th rowSpan={2}>ACTION</th>
      </tr>
      <tr>
        {[
          'BEFORE',
          'AFTER',
          'Y/N',
          'DATE',
          'TIME',
          'Y/N',
          'DATE',
          'TIME',
          'OK QTY.',
          'N.G QTY.',
          'Y/N',
          'DATE',
          'TIME',
          'OK QTY.',
          'N.G QTY.',
          'PROD. HEAD SIGN',
          'QA HEAD SIGN.',
        ].map((head) => (
          <th style={{ textTransform: 'uppercase', minWidth: '120px' }}>
            {head}
          </th>
        ))}
      </tr>
      <tr></tr>
    </thead>
  );
};

export default THead;
